import { EquipmentType } from './models';

export const monolithEquipmentTypeArray = [
  EquipmentType.App,
  EquipmentType.Bike,
  EquipmentType.Elliptical,
  EquipmentType.Fusion,
  EquipmentType.InclineTrainer,
  EquipmentType.Rower,
  EquipmentType.Shoes,
  EquipmentType.StationaryBike,
  EquipmentType.Stepper,
  EquipmentType.Strength,
  EquipmentType.Strider,
  EquipmentType.StudioBike,
  EquipmentType.Treadmill,
  EquipmentType.TDFBike,
  EquipmentType.Wearable,
  EquipmentType.VibrationPlatform,
];
